import React from 'react';
import * as elements from '../data/Elements';
import * as utility from '../data/Utility';

export default class BinaryRadio extends React.Component {
    render() {
        const disabled = utility.propCheck(this.props.disabled, false);
        const hideNotAnswered = utility.propCheck(this.props.hideNotAnswered, false);
        const labelFalse = utility.propCheck(this.props.labelFalse, "No");
        const labelTrue = utility.propCheck(this.props.labelTrue, "Yes");
        const name = utility.propCheck(this.props.name, null);
        const onChangeFalse = utility.propCheck(this.props.onChangeFalse, null);
        const onChangeTrue = utility.propCheck(this.props.onChangeTrue, null);
        const optional = utility.propCheck(this.props.optional, false);
        const title = utility.propCheck(this.props.title, null);
        var value = utility.propCheck(this.props.value, null);

        var falseChecked = false;
        var notAnsweredChecked = value == null;
        var notAnsweredRadio = null;
        var trueChecked = false;

        if (hideNotAnswered) {
            if (notAnsweredChecked) {
                notAnsweredChecked = false;
                value = false;
            }
        }
        else {
            notAnsweredRadio = elements.getRadioInput(name, notAnsweredChecked, true, null, null, "Not Answered");
        }

        if (!notAnsweredChecked) {
            falseChecked = !value;
            trueChecked = value;
        }

        const falseRadio = elements.getRadioInput(name, falseChecked, disabled, onChangeFalse, null, labelFalse);
        const trueRadio = elements.getRadioInput(name, trueChecked, disabled, onChangeTrue, null, labelTrue);

        return elements.getRadioFormGroup(title, optional, notAnsweredRadio, trueRadio, falseRadio);
    }
}



// WEBPACK FOOTER //
// ./src/components/BinaryRadio.js